import { Link } from "react-router-dom";
import "./styles/ServiceCard.css";

function formatDuration(durationMinutes) {
  if (durationMinutes === 60) {
    return "1 hour";
  }

  return `${durationMinutes} min`;
}

function ServiceCard({ isExpanded, onToggle, service }) {
  return (
    <article className={`service-card ${isExpanded ? "is-expanded" : ""}`}>
      <button
        className="service-card-trigger"
        type="button"
        onClick={onToggle}
        aria-expanded={isExpanded}
      >
        <span className="service-card-title">{service.name}</span>
        <span className="service-card-symbol" aria-hidden="true">
          {isExpanded ? "-" : "+"}
        </span>
      </button>

      {isExpanded ? (
        <div className="service-card-panel">
          <p>{service.description}</p>

          <dl className="service-meta-list compact">
            <div>
              <dt>Duration</dt>
              <dd>{formatDuration(service.durationMinutes)}</dd>
            </div>
            <div>
              <dt>Price</dt>
              <dd>{service.priceLabel}</dd>
            </div>
          </dl>

          <Link className="button button-primary" to={`/book/${service.id}`}>
            Book Now
          </Link>
        </div>
      ) : null}
    </article>
  );
}

export default ServiceCard;
